<template>
  <div class="device-changeStatus-dialog">
    <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <div class="title" v-if="model.data.componentDesc" style="margin-bottom: 18px">
            <i class="icon icon-tishi"></i>
            {{ model.data.componentDesc }}
          </div>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('dms_device_changeStatus_modem_dialog.dang_qian_zhuang_tai')">
                {{ getDicValue(model.data.commandStatusDicGroup, model.data.dataValue) }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('dms_device_changeStatus_modem_dialog.qxxzyxcz')" prop="dataValue">
                <el-radio-group v-model="form.dataValue" size="small" class="no-radio">
                  <el-radio border :label="item.value" v-for="item in dictionary" :key="item.value">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveStatus">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        dataValue: '',
      },

      topic: null,
      dicGroup: '',
      bodyNum: '',
      structureId: '',
      dictionary: {},
    };
  },
  mounted() {
    this.initDialog();
    this.getDictionary(`${this.model.data.dicGroup}`, (data) => {
      this.dictionary = data[this.model.data.dicGroup];
    });
  },

  computed: {
    rules() {
      return {
        dataValue: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.form.dataValue = `${this.model.data.dataValue}`;
    },
    // 确认保存菜单
    saveStatus: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saveSumbit();
      });
    },
    saveSumbit: function () {
      const item = this.model.data;
      item.dataValue = this.form.dataValue;
      const params = [];
      params.push(item);
      this.$postJSON(apis.modemBatteryParamItemSave, params).then(() => {
        this.$message({
          message: this.$t('Common.com_modify_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.device-changeStatus-dialog {
  .title {
    padding-left: 10px;
    background: rgba(249, 200, 81, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: rgba(108, 117, 125, 1);
    .icon {
      color: rgba(249, 200, 81, 1);
      margin-right: 10px;
    }
  }
  .no-radio {
    label {
      margin-right: 24px;
      .el-radio__input {
        display: none;
      }
    }
  }
}
</style>
